import { classNames } from "@/react/helpers/twMergeWithCN";
import { AppearanceToggle } from "@circle-react-shared/AppearanceToggle";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";

export const CanvasAppearanceToggle = ({
  className,
}: {
  className?: string;
}) => {
  const { appearance, toggleAppearance, onAppearanceToggle } = useBuilderStore(
    state => ({
      appearance: state.appearance,
      toggleAppearance: state.toggleAppearance,
      onAppearanceToggle: state.onAppearanceToggle,
    }),
  );

  return (
    <div className={classNames("bg-primary rounded-xl p-1", className)}>
      <AppearanceToggle
        currentAppearance={appearance}
        onChange={toggleAppearance}
        onAppearanceToggle={onAppearanceToggle}
      />
    </div>
  );
};
